<!-- VerticalTabItem.vue -->
<template>
  <div
    class="tab"
    :title="showTitle ? computedTitle : ''"
    :tabindex="tabAble ? 0 : -1"
    :class="[
      {
        disabled: disabled,
        active: isActive,
        'no-active-state-on-mobile': noActiveStateOnMobile
      }
    ]"
    @click="handleClick"
  >
    <aha-svg
      v-if="icon.name"
      size="md"
      class="mr-3 flex-shrink-0"
      :name="icon.name"
      :width="icon.width || 20"
      :height="icon.height || 20"
      :viewBox="icon.viewBox"
      :maintainColor="icon.maintainColor"
    />
    <span class="tab-label">{{ computedTitle }}</span>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Object,
      default: () => ({}),
    },
    tabAble: {
      type: Boolean,
      default: false,
    },
    noActiveStateOnMobile: {
      type: Boolean,
      default: false,
    },
    translateLabel: {
      type: Boolean,
      default: true,
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedTitle() {
      return this.translateLabel ? this.$i18nPresenter.t(this.item.label) : this.item.label
    },
  },
  methods: {
    handleClick() {
      if (!this.disabled) {
        this.$emit('select-tab', this.item)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tab {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  cursor: pointer;
  position: relative;
  transition: all 0.1s ease;

  // Truncate to 2 lines
  &-label {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 0px;
    height: 100%;
    background-color: #348EF6;
    transition: 100ms;
    width: 0;
  }

  &:hover,
  &:focus {
    background-color: #F2F7FF;
  }

  &.active {
    font-weight: 700;

    &::before {
      width: 8px;
    }

    @media screen and (min-width: 768px) {
      background-color: #F2F7FF;
    }

    @media screen and (max-width: 767px) {
      &:not(.no-active-state-on-mobile) {
        background-color: #F2F7FF;
      }
    }
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>
